import React, { memo, useContext, useEffect } from 'react'

import Header from '../../../components/Header'
import NavOptions from '../../../components/NavOptions'

import { Container } from './styles'
import { GlobalContext } from '../../../contexts/GlobalContext'
import Footer from '../../LandingPage/Footer'
import { socket } from '../../../util/socket'

const DefaultLayout = memo(({ children, userData }) => {
    const { clienteRobot, user } = useContext(GlobalContext)

    useEffect(() => {
        if(user) {
            socket.connect(user.pessoa)

            return () => {
                socket.detachEvents()
            }
        }
    }, [user])

    if(!clienteRobot) {
        return null
    }

    return (
        <Container>
            <Header usuario={userData} />

            <NavOptions />

            <main>
                {children}
            </main>

            <Footer />
        </Container>
    )
})

export default DefaultLayout
